import React, { useRef, useState, useEffect } from 'react'
import styles from './JSGC.module.css'
import classNames from 'classnames'
import { Button, Card, Col, message, Modal, Row } from 'antd'

import ic_tuijian1 from './img/ic_tuijian1.png'
import ic_tuijian2 from './img/ic_tuijian2.png'
import ic_tuijian3 from './img/ic_tuijian3.png'
import ic_tuijian4 from './img/ic_tuijian4.png'
import ic_tuijian5 from './img/ic_tuijian5.png'
import ic_tuijian6 from './img/ic_tuijian6.png'

import ic_tuijian7 from './img/ic_tuijian7.png'
import ic_tuijian8 from './img/ic_tuijian8.png'

import ic_all_1 from './img/ic_all_1.svg'
import ic_all_2 from './img/ic_all_2.svg'
import ic_all_3 from './img/ic_all_3.svg'
import ic_all_4 from './img/ic_all_4.svg'
import ic_all_5 from './img/ic_all_5.svg'
import ic_all_6 from './img/ic_all_6.svg'
import ic_all_7 from './img/ic_all_7.svg'
import ic_all_8 from './img/ic_all_8.svg'

import HeaderBar from './HeaderBar'
import { useDispatch } from 'react-redux'
import { HTTP_URL } from '../../../util/constants'
import Cookies from 'js-cookie';

const { Meta } = Card

const tuijianListTmp = [
  {
    id: 1,
    title: '我和人工智能的一天',
    content: '我和人工智能的一天，你怎么看',
    img: ic_tuijian1,
  },
  {
    id: 2,
    title: '机器学习',
    content: '让机器习得知识执行任务',
    img: ic_tuijian2,
  },
  {
    id: 3,
    title: '人工智能科普',
    content: '自主武器！AI战争！会成为未来的威胁吗？',
    img: ic_tuijian3,
  },
  {
    id: 4,
    title: '人工神经网络',
    content: '模拟人脑神经元结构和功能',
    img: ic_tuijian4,
  },
  {
    id: 5,
    title: '无监督机器学习',
    content: '无需标注数据，通过算法自动分类',
    img: ic_tuijian5,
  },
  {
    id: 6,
    title: '什么是博弈',
    content: '智能体策略互动，博弈论+强监督',
    img: ic_tuijian6,
  },
]

const fireListTmp = [
  {
    id: 1,
    title: '教师专属指南',
    content: 'AI如何运用在教学生活',
    img: ic_tuijian7,
    num: '113.720w',
  },
  {
    id: 2,
    title: 'AI让你的画动起来',
    content: '人工智能课程-名师工作室',
    img: ic_tuijian8,
    num: '110.582w',
  },
]

const allJsgcList = [
  { id: 1, title: '进化算法', type: 2, img: ic_all_1, price: 99.0 },
  { id: 2, title: '班级管理助手', type: 1, img: ic_all_2, price: 100 },
  { id: 3, title: '探秘人工智能', type: 3, img: ic_all_3, price: 99.0 },
  { id: 4, title: 'AI让你的画动起来', type: 3, img: ic_all_4, price: 90.0 },
  { id: 5, title: '教师专属AI指南', type: 2, img: ic_all_5, price: 99.0 },
  { id: 6, title: '教学反思', type: 1, img: ic_all_6, price: 90.0 },
  { id: 7, title: 'AI绘画', type: 3, img: ic_all_7, price: 90.0 },
  { id: 8, title: '感知AI-名师工作室', type: 3, img: ic_all_8, price: 119.0 },
]

export default function JsgcHome(props) {
  const [tuijianList, setTuijianList] = useState(tuijianListTmp)
  const [jsgcList, setJsgcList] = useState(allJsgcList)
  const [valueBt, setValueBt] = useState(0)
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const [showVideo, setShowVideo] = useState(false)

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function createBotMethod(params) {
    props.jumpToCreateBot(6)
  }

  const handleClickBt = (bt) => {
    console.log(bt)
    setValueBt(bt)
    if (bt === 0) {
      setJsgcList(allJsgcList)
      return
    }
    const newList = allJsgcList.filter((item) => item.type === bt)

    setJsgcList(newList)
  }

  return (
    <div className={styles.background}>
      <HeaderBar
        createBot={createBotMethod}
        confirmSearch={(value) => {
          props.globalSearch(value, 1)
        }}
      />

      <div className={styles['div-top']}>
        <div className={styles['div-top-left']}>
          <span className={styles['text-tuijian']}>推荐</span>
          <div className={styles['div-tuijian']}>
            {Array.from({ length: Math.ceil(tuijianList.length / 3) }).map(
              (_, rowIndex) => (
                <Row gutter={20} key={rowIndex} style={{ marginBottom: 10 }}>
                  {tuijianList
                    .slice(rowIndex * 3, (rowIndex + 1) * 3)
                    .map((item) => (
                      <Col span={8} key={item.title}>
                        <Card
                          onClick={() => {
                            // 视频已删除，暂时屏蔽
                            // if (item.id === 1) {
                            //   window.open(require('./名师讲堂/2.mp4'), '_blank')
                            // }
                            // if (item.id === 2) {
                            //   window.open(require('./名师讲堂/3.mp4'), '_blank')
                            // }
                            // if (item.id === 3) {
                            //   window.open(require('./名师讲堂/4.mp4'), '_blank')
                            // }
                            // if (item.id === 4) {
                            //   window.open(
                            //     require('./video/rengongshenjingwangluo.mp4'),
                            //     '_blank',
                            //   )
                            // }
                            // if (item.id === 5) {
                            //   window.open(
                            //     require('./video/wujianduxuexi.mp4'),
                            //     '_blank',
                            //   )
                            // }
                            // if (item.id === 6) {
                            //   window.open(require('./名师讲堂/5.mp4'), '_blank')
                            // }
                          }}
                          style={{ border: 'none', cursor: 'pointer' }}
                          className={styles.card3}
                          cover={
                            <div
                              style={{ position: 'relative' }}
                              className={styles['card3-img']}
                            >
                              <img
                                alt={item.title}
                                src={item.img}
                                className={styles['card3-img']}
                                style={{ border: 'none', cursor: 'pointer' }}
                              />
                              <img
                                src={require('./img/ic_video.png')}
                                style={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  cursor: 'pointer',
                                  // display:item.id===1||item.id===2||item.id===3||item.id===6?'block':'none'
                                }}
                              />
                            </div>
                          }
                        >
                          <Meta
                            style={{
                              padding: 0, // 去掉整体内边距
                              marginLeft: -20, // 去掉外边距，可按需调整
                              marginRight: -20, // 去掉外边距，可按需调整
                            }}
                            title={
                              <div className={styles['item-tuijian-title']}>
                                {item.title}
                              </div>
                            }
                            description={
                              <div className={styles['item-tuijian-content']}>
                                {item.content}
                              </div>
                            }
                          />
                        </Card>
                      </Col>
                    ))}
                </Row>
              ),
            )}
          </div>
        </div>

        <div className={styles['div-top-right']}>
          <div className={styles['div-fire']}>
            <img src={require('./img/ic_fire.png')} />
            <span style={{ color: '#091B3D', marginLeft: 6 }}>最受欢迎</span>
          </div>

          <div className={styles['div-welcome']}>
            {fireListTmp.map((item) => (
              <Card
                onClick={() => {
                  // 视频/PDF已删除，暂时屏蔽
                  // if (item.id === 1) {
                  //   window.open(require('./jsai.mp4'), '_blank')
                  // }
                  // if (item.id === 2) {
                  //   window.open(
                  //     require('./课件-PDF/2.pdf'),
                  //     '_blank',
                  //     'noopener,noreferrer',
                  //   )
                  // }
                }}
                className={styles.card4}
                style={{ border: 'none' }}
                // cover={<img alt={item.title} src={item.img}  className={styles["item-fire-img"]}/>}
                cover={
                  <div style={{ position: 'relative' }}>
                    <img
                      alt="example"
                      src={item.img}
                      className={styles['card4-img']}
                    />
                    <img
                      src={require('./img/ic_video.png')}
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        cursor: 'pointer',
                      }}
                    />
                  </div>
                }
              >
                <Meta
                  title={
                    <div className={styles['tag-fire']}>
                      #教学 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; #人工智能
                    </div>
                  }
                  style={{
                    padding: 0, // 去掉整体内边距
                    marginLeft: -20, // 去掉外边距，可按需调整
                    marginRight: -20,
                  }}
                  description={
                    <div>
                      <p className={styles['title-fire']}>{item.title}</p>
                      <p className={styles['content-fire']}>{item.content}</p>
                    </div>
                  }
                />
                <div className={styles['div-num']}>
                  <span>{item.num}</span>
                  <img
                    style={{ marginLeft: 5 }}
                    src={require('./img/ic_search.png')}
                  />

                  <span style={{ marginLeft: 30 }}>@李老师</span>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.title}>
        <span style={{ fontSize: 20, marginTop: 30 }}>教师共创</span>
      </div>

      <div className={styles['div-tab']}>
        <button
          className={valueBt === 0 ? styles['button-select'] : styles.button}
          onClick={() => handleClickBt(0)}
        >
          全部
        </button>
        <button
          className={valueBt === 1 ? styles['button-select'] : styles.button}
          onClick={() => handleClickBt(1)}
        >
          共创智能体
        </button>
        <button
          className={valueBt === 2 ? styles['button-select'] : styles.button}
          onClick={() => handleClickBt(2)}
        >
          教师研修
        </button>
        <button
          className={valueBt === 3 ? styles['button-select'] : styles.button}
          onClick={() => handleClickBt(3)}
        >
          研选课例
        </button>
      </div>

      <div className={styles['div-bottom']}>
        {Array.from({ length: Math.ceil(jsgcList.length / 4) }).map(
          (_, rowIndex) => (
            <Row gutter={25} key={rowIndex}>
              {jsgcList.slice(rowIndex * 4, (rowIndex + 1) * 4).map((item) => (
                <Col span={6} key={item.title}>
                  <Card
                    onClick={() => {
                      if (item.id === 1) {
                        // 视频已删除，暂时屏蔽
                        // window.open(
                        //   require('./video/jinhuasuanfa.mp4'),
                        //   '_blank',
                        // )
                      }
                      if (item.id === 2) {
                        window.open(
                          HTTP_URL +
                            '/gongju/preview/index.html?botId=7502340912027566099&icon=aHR0cHM6Ly90Z25wLm9zcy1jbi1xaW5nZGFvLmFsaXl1bmNzLmNvbS95Z2JoL2FnZW50L2NsYXNzLnBuZw==&title=%E7%8F%AD%E7%BA%A7%E7%AE%A1%E7%90%86%E5%8A%A9%E6%89%8B&userToken=' +
                            Cookies.get("userToken"),
                        )
                      }
                      if (item.id === 3) {
                        // PDF已删除，暂时屏蔽
                        // window.open(
                        //   require('./课件-PDF/1.pdf'),
                        //   '_blank',
                        //   'noopener,noreferrer',
                        // )
                      }
                      if (item.id === 4) {
                        // PDF已删除，暂时屏蔽
                        // window.open(
                        //   require('./课件-PDF/2.pdf'),
                        //   '_blank',
                        //   'noopener,noreferrer',
                        // )
                      }
                      if (item.id === 5) {
                        // 视频已删除，暂时屏蔽
                        // window.open(require('./jsai.mp4'), '_blank')
                      }
                      if (item.id === 8) {
                        // 视频已删除，暂时屏蔽
                        // window.open(
                        //   require('./名师讲堂/ganzhiAi.mp4'),
                        //   '_blank',
                        // )
                      }
                    }}
                    style={{ border: 'none', marginTop: 20 }}
                    className={styles.card4}
                    cover={
                      <div
                        style={{ position: 'relative' }}
                        className={styles['card4-img']}
                      >
                        <img
                          alt="example"
                          src={item.img}
                          className={styles['card4-img']}
                          style={{ border: 'none', cursor: 'pointer' }}
                        />
                        <div
                          className={styles['item-gc']}
                          style={{
                            position: 'absolute',
                            top: '5%',
                            left: '5%',
                            background:
                              item.type === 1
                                ? '#F5B544'
                                : item.type === 2
                                  ? '#E6521F'
                                  : item.type === 3
                                    ? '#4B9F47'
                                    : '#ffffff',
                          }}
                        >
                          {item.type === 1
                            ? '共创智能体'
                            : item.type === 2
                              ? '教师研修'
                              : item.type === 3
                                ? '研选课例'
                                : ''}
                        </div>

                        <img
                          src={require('./img/ic_video.png')}
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            cursor: 'pointer',
                            display:
                              item.id === 1 ||
                              item.id === 2 ||
                              item.id === 3 ||
                              item.id === 4 ||
                              item.id === 5 ||
                              item.id === 8
                                ? 'block'
                                : 'none',
                          }}
                        />
                      </div>
                    }
                  >
                    <Meta
                      style={{
                        padding: 0, // 去掉整体内边距
                        marginLeft: -20, // 去掉外边距，可按需调整
                        marginRight: -20, // 去掉外边距，可按需调整
                      }}
                      // title={}
                    />
                    <div className={styles['gc-title']}>{item.title}</div>

                    {/* <div className={styles["div-price"]}>
                    <div className={styles["text-price"]}>¥ {item.price.toFixed(2)}</div>
                    <div className={styles["div-pay"]}>
                      <img style={{ marginLeft:5 ,width:16,height:16}} src={require('./img/ic_shoping.png')}/>
                      <div
                        type='primary'
                        className={styles["bt-pay"]}
                      >
                        支付
                      </div>
                    </div>
                  </div> */}
                  </Card>
                </Col>
              ))}
            </Row>
          ),
        )}
      </div>
    </div>
  )
}
